import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputTextSF from '../../widgets/form/InputTextSF'
import InputSelectUI from '../../widgets/form/InputSelectUI'

const UserInviteByPhoneUI = ({context, messageList,
  // phone
  phone, onPhoneChange, phoneError, setPhoneError,
  // account role
  accountRoleId, accountRoleList, onaccountRoleIdChange, accountRoleIdError,
  // form
  onSubmit, submitted, successMsg, errorList, setErrorList,
  }) =>
  <CardUI context={context}>
    <FormSF context={context} messageList={messageList} buttonMessageKey='c_invite'
      onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
      busy={submitted}>
      <InputTextSF type='text' name='phone' required={true} maxLength={64}
        messageList={messageList} labelKey='c_phone'
        value={phone} onChange={onPhoneChange}
        error={phoneError} setError={setPhoneError}
        autoFocus={true}
      />
      <InputSelectUI name='accountRoleId' value={accountRoleId} required={true}
        messageList={messageList} labelKey='c_account_role'
        optionList={accountRoleList}
        onChange={onaccountRoleIdChange} error={accountRoleIdError}
      />
    </FormSF>
  </CardUI>

export default UserInviteByPhoneUI
